import { render, staticRenderFns } from "./ui_element_code.vue?vue&type=template&id=457ca13f&scoped=true&lang=pug&"
import script from "./ui_element_code.vue?vue&type=script&lang=js&"
export * from "./ui_element_code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ca13f",
  null
  
)

export default component.exports